import React from 'react';

// 0-100% slider with tick labels, same gradient-fill technique already used
// for the "Distance Range" filter slider in ChooseAmbulancecardDuplicate.jsx —
// no shared Slider/Range component exists yet in src/components/ui, so this
// is a small local one scoped to the booking form.
export const PercentSlider = ({ label, value, onChange }) => {
  const ticks = [0, 25, 50, 75, 100];
  return (
    <div>
      {label && <label className="text-xs font-semibold text-gray-500 mb-2 block">{label}</label>}
      <input
        type="range"
        min="0"
        max="100"
        step="1"
        value={value}
        onChange={(e) => onChange(Number(e.target.value))}
        className="w-full h-2 bg-gray-200 rounded-lg appearance-none cursor-pointer command-center-slider"
        style={{
          background: `linear-gradient(to right, hsl(var(--primary)) 0%, hsl(var(--primary)) ${value}%, #e5e7eb ${value}%, #e5e7eb 100%)`,
        }}
      />
      <div className="flex justify-between text-xs text-gray-500 mt-1.5">
        {ticks.map((t) => (
          <span key={t}>{t}%</span>
        ))}
      </div>
      <style>{`
        .command-center-slider::-webkit-slider-thumb {
          -webkit-appearance: none;
          appearance: none;
          width: 18px;
          height: 18px;
          border-radius: 9999px;
          background: hsl(var(--primary));
          border: 2px solid white;
          box-shadow: 0 1px 3px rgba(0,0,0,0.3);
          cursor: pointer;
        }
        .command-center-slider::-moz-range-thumb {
          width: 18px;
          height: 18px;
          border-radius: 9999px;
          background: hsl(var(--primary));
          border: 2px solid white;
          box-shadow: 0 1px 3px rgba(0,0,0,0.3);
          cursor: pointer;
        }
      `}</style>
    </div>
  );
};

// Simple Yes/No pill toggle — no Switch/Toggle component exists yet either,
// styled after the app's existing selected/unselected "radio pill card" look.
export const YesNoToggle = ({ label, value, onChange }) => (
  <div>
    {label && <label className="text-xs font-semibold text-gray-500 mb-2 block">{label}</label>}
    <div className="grid grid-cols-2 gap-2">
      {['Yes', 'No'].map((option) => {
        const isSelected = value === option;
        return (
          <button
            key={option}
            type="button"
            onClick={() => onChange(option)}
            className={`px-3 py-2 rounded-md border text-sm font-medium transition-colors ${
              isSelected
                ? 'border-primary bg-primary/5 text-primary'
                : 'border-gray-200 text-gray-600 hover:bg-gray-50'
            }`}
          >
            {option}
          </button>
        );
      })}
    </div>
  </div>
);
